import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  WHOLESALER_ADD_REQUEST,
  WHOLESALER_ADD_SUCCESS,
  WHOLESALER_ADD_FAILURE,
  WHOLESALER_EDIT_REQUEST,
  WHOLESALER_EDIT_SUCCESS,
  WHOLESALER_EDIT_FAILURE,
  WHOLESALER_VIEW_REQUEST,
  WHOLESALER_VIEW_SUCCESS,
  WHOLESALER_VIEW_FAILURE,
  WHOLESALER_VIEW_ALL_REQUEST,
  WHOLESALER_VIEW_ALL_SUCCESS,
  WHOLESALER_VIEW_ALL_FAILURE,
  WHOLESALER_DELETE_REQUEST,
  WHOLESALER_DELETE_SUCCESS,
  WHOLESALER_DELETE_FAILURE,
  WHOLESALER_RESET_STATE,
  WHOLESALER_SEARCH_SUCCESS,
  WHOLESALER_SEARCH_REQUEST,
  WHOLESALER_SEARCH_FAILURE,
} from "./WholesalerTypes";

const initialState = {
  addWholesaler: { ...defaultStatus },
  editWholesaler: { ...defaultStatus },
  deleteWholesaler: { ...defaultStatus },
  viewWholesaler: { ...defaultStatus },
  viewAllWholesalers: { ...defaultStatus },
  viewAllSearchWholesaler: { ...defaultStatus },
};

const WholesalerReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case WHOLESALER_ADD_REQUEST:
      return {
        ...state,
        addWholesaler: { ...defaultStatus, inProgress: true, ...payload },
      };
    case WHOLESALER_ADD_SUCCESS:
      return {
        ...state,
        addWholesaler: { ...defaultStatus, success: true, ...payload },
      };
    case WHOLESALER_ADD_FAILURE:
      return {
        ...state,
        addWholesaler: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          errorFields: payload?.errorFields || null,
          ...payload,
        },
      };

    case WHOLESALER_EDIT_REQUEST:
      return {
        ...state,
        editWholesaler: { ...defaultStatus, inProgress: true, ...payload },
      };
    case WHOLESALER_EDIT_SUCCESS:
      return {
        ...state,
        editWholesaler: { ...defaultStatus, success: true, ...payload },
      };
    case WHOLESALER_EDIT_FAILURE:
      return {
        ...state,
        editWholesaler: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          errorFields: payload?.errorFields || null,
          ...payload,
        },
      };

    case WHOLESALER_VIEW_REQUEST:
      return {
        ...state,
        viewWholesaler: { ...defaultStatus, inProgress: true, ...payload },
      };
    case WHOLESALER_VIEW_SUCCESS:
      return {
        ...state,
        viewWholesaler: { ...defaultStatus, success: true, ...payload },
      };
    case WHOLESALER_VIEW_FAILURE:
      return {
        ...state,
        viewWholesaler: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    case WHOLESALER_VIEW_ALL_REQUEST:
      return {
        ...state,
        viewAllWholesalers: { ...defaultStatus, inProgress: true, ...payload },
      };
    case WHOLESALER_VIEW_ALL_SUCCESS:
      return {
        ...state,
        viewAllWholesalers: { ...defaultStatus, success: true, data: payload },
      };
    case WHOLESALER_VIEW_ALL_FAILURE:
      return {
        ...state,
        viewAllWholesalers: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Search View All
    case WHOLESALER_SEARCH_REQUEST:
      return {
        ...state,
        viewAllSearchWholesaler: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_SEARCH_SUCCESS:
      return {
        ...state,
        viewAllSearchWholesaler: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case WHOLESALER_SEARCH_FAILURE:
      return {
        ...state,
        viewAllSearchWholesaler: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    case WHOLESALER_DELETE_REQUEST:
      return {
        ...state,
        deleteWholesaler: { ...defaultStatus, inProgress: true, ...payload },
      };
    case WHOLESALER_DELETE_SUCCESS:
      return {
        ...state,
        deleteWholesaler: { ...defaultStatus, success: true, ...payload },
      };
    case WHOLESALER_DELETE_FAILURE:
      return {
        ...state,
        deleteWholesaler: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    case WHOLESALER_RESET_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default WholesalerReducer;
